import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Task } from '@interfaces/task/task';
import { NgClass, UpperCasePipe } from '@angular/common';
import { ExtractNameFromLocationPipe } from '@features/dashboard/pipes/extract-name-from-location.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TaskService } from '@services/task.service';
import { TaskStatus } from '../../../../enums/task-status';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseDialogComponent } from '@shared/dialogs/base-dialog/base-dialog.component';
import { DialogAction } from '@features/dashboard/components/alert/enums/dialogAction';
import { environment } from 'src/environments/environment';
import { CustomFullDatePipe } from 'src/app/pipes/custom-full-date';

@Component({
  selector: 'app-task-item',
  standalone: true,
  imports: [
    CustomFullDatePipe,
    NgClass,
    TranslateModule,
    UpperCasePipe,
    ExtractNameFromLocationPipe,
  ],
  templateUrl: './task-item.component.html',
  styleUrl: './task-item.component.scss',
})
export class TaskItemComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) task!: Task;
  @ViewChild('taskItem') taskItem!: ElementRef;

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    this.closeAllDialogs();
  }

  private taskService = inject(TaskService);
  protected readonly taskStatus = TaskStatus;
  private dialog = inject(MatDialog);
  private translateService = inject(TranslateService);
  private dialogRef?: MatDialogRef<BaseDialogComponent>;
  isWlmhEnabled = environment.isWlmhEnabled;
  @Input() canvasBody!: HTMLDivElement;

  ngAfterViewInit(): void {
    this.canvasBody?.addEventListener('scroll', this.onScroll.bind(this));
  }

  ngOnDestroy(): void {
    this.canvasBody?.removeEventListener('scroll', this.onScroll.bind(this));
  }

  openCloseTaskDialog(event: MouseEvent) {
    this.closeAllDialogs();
    const taskElement = (event.target as HTMLElement).closest('.task-item');
    if (taskElement) {
      const taskRect = taskElement.getBoundingClientRect();

      // Calculate dynamic positions
      const topPosition = taskRect.top + 'px';
      const leftPosition = taskRect.left - 400 + 'px'; // Open dialog 400px to the left

      this.dialogRef = this.dialog.open(BaseDialogComponent, {
        width: '370px',
        height: '140px',
        data: {
          title: this.translateService.instant('front.dialog.close-task-title'),
          message: this.translateService.instant(
            'front.dialog.close-task-message',
          ),
        },
        position: {
          top: topPosition,
          left: leftPosition, // Place dialog on the left side
        },
        panelClass: 'custom-dialog-polygon',
      });

      this.dialogRef.afterClosed().subscribe((result: DialogAction) => {
        if (DialogAction.SUBMIT === result) {
          this.taskService.closeTask(this.task);
        }
      });
    }
  }

  private closeAllDialogs() {
    this.dialog.closeAll();
  }
}
